import { Link, useLocation } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext";
import { LayoutDashboard, Ticket, Plus, User, Settings } from "lucide-react";
import brandLogo from "../../assets/images/IX.png";
const Sidebar = () => {
  const { user } = useAuth();
  const location = useLocation();
  const userData = typeof user === "string" ? JSON.parse(user) : user;
  const isEmployee =
    userData &&
    (userData.Department === "Engineering" ||
      userData.Department === "BD" ||
      userData.Department === "Business Development");

  const menuItems = [
    ...(!isEmployee
      ? [
          {
            icon: LayoutDashboard,
            label: "Dashboard",
            path: "/dashboard",
          },
        ]
      : []),
    {
      icon: Ticket,
      label: "My Tickets",
      path: "/my-tickets",
    },
    ...(!isEmployee
      ? [
          {
            icon: Settings,
            label: "Manage Categories",
            path: "/manage-categories",
          },
        ]
      : []),
    {
      icon: Plus,
      label: "Create Ticket",
      path: "/create-ticket",
    },
    {
      icon: User,
      label: "Profile",
      path: "/profile",
    },
  ];

  return (
    <div className="fixed left-0 top-0 h-full w-64 bg-white border-r border-gray-200 flex flex-col">
      {/* Logo */}
      <div className="p-8 border-b border-gray-200">
        <img src={brandLogo} alt="brandlogo" width={"80%"} />
      </div>

      {/* Navigation */}
      <nav className="flex-1 p-4 ">
        <ul className="space-y-2">
          {menuItems.map((item) => {
            const isActive = location.pathname === item.path;
            return (
              <li key={item.path}>
                <Link
                  to={item.path}
                  className={`flex items-center gap-3 px-3 py-2 rounded-lg transition-colors ${
                    isActive
                      ? "bg-incub-blue-100 text-incub-blue-700"
                      : "text-gray-600 hover:bg-gray-100"
                  }`}
                >
                  <item.icon className="h-5 w-5" />
                  {item.label}
                </Link>
              </li>
            );
          })}
        </ul>
      </nav>
    </div>
  );
};

export default Sidebar;
